import { render } from "./NoteForm.vue?vue&type=template&id=b2d28dec&scoped=true"
import script from "./NoteForm.vue?vue&type=script&lang=js"
export * from "./NoteForm.vue?vue&type=script&lang=js"

import "./NoteForm.vue?vue&type=style&index=0&id=b2d28dec&lang=scss"
import "./NoteForm.vue?vue&type=style&index=1&id=b2d28dec&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2d28dec"]])

export default __exports__